(() => {
  const sortForm = document.querySelector('[data-collection-sort]');
  if (sortForm) {
    const select = sortForm.querySelector('select');
    select?.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  }
})();
